export const getInnerElementsSizes = ref => {
  var _a;
  if (!ref.current || !((_a = ref.current) === null || _a === void 0 ? void 0 : _a.children)) return [];
  const innerItems = ref.current.children;
  const sizes = Array.from(innerItems).map(item => {
    const {
      offsetLeft,
      offsetWidth
    } = item;
    return offsetLeft + offsetWidth;
  });
  return sizes;
};